import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, AgentFieldValidationDto, AgentProvisionFormDataDto, DocumentDto, MaskingDto, MsisdnDto, PartnerDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpMaskingService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/masking', authService);
	}

	public get(): Observable<MaskingDto[]> {
		return super.doGet(true, `/`);
	}
	public save(input: MaskingDto[]): Observable<MaskingDto[]>{
		return super.doPost(true, `/`, input);
	}
}
